//PriceChangeAll page

import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../../components/Navbar";
import ConnectionTable from "../../components/ConnectionTable";
// import PriceList from "../../components/PriceListTable";
import PriceListTableAll from "../../components/PriceListTableAll";
import "./styles.css";

//Price List Page
const PricesChangeAll = () => {
  // const [sucursales, setSucursales] = useState([]);

  const [prices, setPrices] = useState([]);
  const [editedPrices, setEditedPrices] = useState([]);

  // const [editSucursales, setEditSucursales] = useState();
  // const [addLocation, setAddLocation] = useState();
  // const [status, setStatus] = useState({});
  // const [statusLoading, setStatusLoading] = useState(true);

  const config = {
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const rerender = () => {
    // axios
    //   .get("/api/data/getconnections", config)
    //   .then((res) => {
    //     setSucursales(res.data);
    //     setEditSucursales(res.data);
    //     setAddLocation(res.data);
    //   })
    //   .catch((err) => console.log(err));
    // axios
    //   .get("/api/data/ping", config)
    //   .then((res) => {
    //     setStatus(res.data);
    //     setStatusLoading(false);
    //     console.log("ping", res);
    //   })
    //   .catch((e) => console.log(e));
  };

  // useEffect(() => {
  //   axios
  //     .get("/api/data/getprices", config)
  //     .then((res) => {
  //       console.log(res.data);
  //       setPrices(res.data[0]);
  //       // setEditSucursales(res.data);
  //       // setAddLocation(res.data);
  //     })
  //     .then(() => {
  //       console.log("setting editedprices");
  //       setEditedPrices(
  //         prices.map((e) => ({
  //           MenuItemPortionId: e.MenuItemPortionId,
  //           Price: e.Price,
  //         }))
  //       );
  //     })
  //     .catch((err) => console.log(err));

  //   // axios
  //   //   .get("/api/data/ping", config)
  //   //   .then((res) => {
  //   //     setStatus(res.data);
  //   //     setStatusLoading(false);
  //   //     console.log("ping", res);
  //   //   })
  //   //   .catch((e) => console.log(e));
  // }, []);

  // useEffect(() => {
  //   axios
  //     .get("/api/data/getprices", config)
  //     .then((res) => {
  //       console.log(res.data);
  //       setPrices(res.data[0]);
  //     })
  //     .then(() => {
  //       console.log("setting editedprices");
  //       setEditedPrices(
  //         prices.map((e) => ({
  //           MenuItemPortionId: e.MenuItemPortionId,
  //           Price: e.Price,
  //         }))
  //       );
  //     })
  //     .catch((err) => console.log(err));
  // }, []);

  // useEffect(() => {
  //   console.log(`console.log second useEffect`, editedPrices); // This will log the updated editedPrices state
  // }, [editedPrices]);

  // useEffect(() => {
  //   axios
  //     .get("/api/data/getprices", config)
  //     .then((res) => {
  //       console.log(res.data);
  //       setPrices(res.data[0]);
  //     })
  //     .then(() => {
  //       if (prices && prices.length > 0) {
  //         // Add this check
  //         console.log("setting editedprices");
  //         setEditedPrices(
  //           prices.map((e) => ({
  //             MenuItemPortionId: e.MenuItemPortionId,
  //             Price: e.Price,
  //           }))
  //         );
  //       } else {
  //         console.log(`prices not ready`);
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // }, []);

  // useEffect(() => {
  //   console.log(editedPrices);
  // }, [editedPrices]);

  // useEffect(() => {
  //   axios
  //     .get("/api/data/getprices", config)
  //     .then((res) => {
  //       console.log(res.data);
  //       setPrices(res.data[0]);
  //     })
  //     .catch((err) => console.log(err));
  // }, []);

  // useEffect(() => {
  //   if (prices && prices.length > 0) {
  //     console.log("setting editedprices");
  //     setEditedPrices(
  //       prices.map((e) => ({
  //         MenuItemPortionId: e.MenuItemPortionId,
  //         Price: e.Price,
  //       }))
  //     );
  //   }
  // }, [prices]); // This effect will re-run whenever prices changes

  useEffect(() => {
    let isMounted = true; // Add this flag

    axios
      .get("/api/data/getprices", config)
      .then((res) => {
        if (isMounted) {
          // Check the flag before updating state
          setPrices(res.data[0]);
        }
      })
      .catch((err) => console.log(err));

    return () => {
      // Add this cleanup function
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (prices && prices.length > 0) {
      console.log("setting editedprices");
      setEditedPrices(
        prices.map((e) => ({
          MenuItemPortionId: e.MenuItemPortionId,
          Price: e.Price,
        }))
      );
    }
  }, [prices]);

  console.log(editedPrices);

  return (
    <div className="container">
      <Navbar />
      <div>Hola</div>
      <div className="pricelisttable">
        <PriceListTableAll
          rerender={rerender}
          // branches={branches}
          prices={prices}
          editedPrices={editedPrices}
          setEditedPrices={setEditedPrices}
          // status={status}
          // statusLoading={statusLoading}
          // setSucursales={setSucursales}
          // editSucursales={editSucursales}
          // setEditSucursales={setEditSucursales}
          // addLocation={addLocation}
          // setAddLocation={setAddLocation}
        />
      </div>
    </div>
  );
};

export default PricesChangeAll;
